import React from "react";
import { Icon } from "../Icon/Icon";

// Handle events are passed as ...props, to be managed by the parent component
export const Button = (
  {
    containerId,
    buttonIcon,
    customClasses,
    color,
    iconName,
    label,
    mode,
    negative,
    positionIcon,
    type,
    uppercase,
    withIcon,
    linkUrl,
    ...props
  },
  ref
) => {
  // setting classes
  const _color = color && `--${color}`;
  const _withIcon = withIcon === "yes" ? `--with-icon` : "";
  const _positionIcon = positionIcon && `--icon-${positionIcon}`;
  const _negative = negative === "yes" ? `--negative` : "";
  const _uppercase = uppercase === "yes" ? `--uppercase` : "";
  const _arrow =
    !iconName || buttonIcon || iconName === " " ? `--animated-arrow` : "";
  const _mode = mode === "inactive" ? `disabled` : "";

  return (
    <div className={["btn-wrap", customClasses].join(" ")} id={containerId}>
      {/* if there the type is link? render link : render button */}
      {type === "link" ? (
        <a
          href={linkUrl}
          className={[
            "btn",
            _color,
            _withIcon,
            _positionIcon,
            _negative,
            _uppercase,
            _arrow,
          ].join(" ")}
          {...props}
        >
          <p>{label}</p>
          {withIcon === "yes" ? (
            <Icon setViewBox="yes" name={iconName ? iconName : "arrow-right"} />
          ) : (
            ""
          )}
        </a>
      ) : (
        <div className="innerBtnWrap">
          <button
            type="submit"
            className={[
              "btn",
              _color,
              _withIcon,
              _positionIcon,
              _negative,
              _uppercase,
              _arrow,
              _mode,
            ].join(" ")}
            disabled={mode === "inactive" ? true : false}
            {...props}
          >
            <p>{label}</p>
            <span className="tooltip">
              Compila tutti i campi per procedere con la tua richiesta di
              prestito.
            </span>
            {withIcon === "yes" ? (
              <Icon
                setViewBox="yes"
                name={iconName ? iconName : "arrow-right"}
              />
            ) : (
              ""
            )}
          </button>
        </div>
      )}
    </div>
  );
};
